import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ColDef, GridApi, ICellRendererParams } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { AppRoleOption } from 'src/app/app-roles';
import { buildRoleAccessColumns, setRoleAccess } from '../menu-role-access';

@Component({
  selector: 'app-manage-sub-sub-menu-items',
  templateUrl: './manage-sub-sub-menu-items.component.html',
  styleUrls: ['./manage-sub-sub-menu-items.component.scss']
})
export class ManageSubSubMenuItemsComponent implements ICellRendererAngularComp {
  sub_sub_menu_items: any[] = [];
  private gridApi!: GridApi;
  params!: ICellRendererParams<any, any, any>;

  constructor(private http: HttpClient, private toastr: ToastrService) { }

  subSubMenuColumnDefs: ColDef[] = [
    {
      field: 'ams_side_sub_sub_menu_text',
      headerName: 'Sub Sub Menu',
      width: 240,
      minWidth: 220,
      pinned: 'left',
      lockPinned: true,
    },
    ...buildRoleAccessColumns('ams_side_sub_sub_menu_text', (checked, params, role) => {
      this.checkboxChanged(checked, params, role);
    }),
  ];

  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: false,
  };

  onGridReady(params: any) {
    this.gridApi = params.api;
  }

  checkboxChanged(checked: boolean, params: ICellRendererParams<any, any, any>, role: AppRoleOption) {
    const row = params.data;
    const subSubMenuId = row?.ams_side_sub_sub_menu_id;

    if (!subSubMenuId) {
      return;
    }

    const previousAccessRoles = row.access_roles;
    const nextAccessRoles = setRoleAccess(previousAccessRoles, role.value, checked);

    if (nextAccessRoles === Number(previousAccessRoles)) {
      return;
    }

    row.access_roles = nextAccessRoles;
    params.api.refreshCells({ rowNodes: params.node ? [params.node] : undefined, force: true });

    this.http.get('/api/menu_manager/menu_manager.php', {
      params: { type: 'updateAccessSubSubMenu', access_roles: nextAccessRoles, menu_id: subSubMenuId }
    }).subscribe({
      next: () => {
        this.toastr.success(`${role.label} access updated.`);
        this.loadSubSubMenuItems(this.params?.data?.ams_side_sub_menu_id);
      },
      error: () => {
        row.access_roles = previousAccessRoles;
        params.api.refreshCells({ rowNodes: params.node ? [params.node] : undefined, force: true });
        this.toastr.error('Unable to update sub-sub-menu access.');
      }
    });
  }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    this.loadSubSubMenuItems(params.data?.ams_side_sub_menu_id);
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.params = params;
    this.loadSubSubMenuItems(params.data?.ams_side_sub_menu_id);
    return true;
  }

  private loadSubSubMenuItems(subMenuId: any) {
    if (!subMenuId) {
      this.sub_sub_menu_items = [];
      return;
    }

    this.http.get('/api/menu_manager/menu_manager.php', {
      params: { type: 'subSubMenuFilteredByMenuId', menu_id: subMenuId }
    }).subscribe((response: any) => {
      this.sub_sub_menu_items = response ?? [];
    });
  }

}
